import * as React from 'react';
import './TeamTest.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../stores';
import { IMyGroup } from '../../../interfaces/IMyGroup';
import Group from './group/Group';
import { IGroup } from '../../../interfaces/IGroup';
import GroupService from '../../../services/GroupService';
import { Pivot } from '../../pivot/Pivot';
import GroupsPanel from './groupsPanel/GroupsPanel';
import ProductService from '../../../services/ProductService';

export interface IProps {
  open: boolean;
  close: () => void;
  appStore?: AppStore;
}

export interface IState {
  showButtons: boolean;
  selectedPivot?: string;
  hasAccess?: boolean;
  loadingGroups?: boolean;
}

@inject('appStore')
@observer
export default class TeamTest extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      showButtons: false,
      selectedPivot: "member",
      loadingGroups: false
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (this.props.open !== props.open && props.open) {
      this.getMyGroups();
      setTimeout(() => {
        this.setState({ showButtons: true });
      }, 500);
    }
  }

  private async getMyGroups(): Promise<void> {
    if (this.props.appStore?.user?.id) {
      this.setState({ loadingGroups: true });
      if (this.props.appStore!.user?.userType === "admin") {
        await GroupService.getGroups().then((groups: IGroup[]) => {
          this.props.appStore!.adminGroups = groups;
          this.setState({ loadingGroups: false });
        });
      } else {
        await GroupService.getGroupsForOwnerAndAdminUser(this.props.appStore?.user?.id).then((groups: IGroup[]) => {
          this.props.appStore!.adminGroups = groups;
          this.setState({ loadingGroups: false });
        });
      }

      ProductService.productAccess("26647", this.props.appStore!.user.username).then((doYouKnowTheType: any) => {
        if (doYouKnowTheType?.results?.length > 0) {
          this.setState({ hasAccess: true });
        }
      });
    }
  }

  render() {
    const adminGroups = [];
    if (this.props.appStore!.adminGroups?.length > 0) {
      this.props.appStore!.adminGroups.forEach((adminGroup: IGroup) => {
        adminGroups.push(
          <Group
            key={adminGroup.objectId}
            isAdmin
            showResultButton={true}
            group={{
              group: adminGroup,
              groupMemberInfo: undefined
            }}
            style={{
              height: "275px"
            }}
            getMyGroups={() => this.getMyGroups()}
          />
        );
      });
    }
    return (
      <div
        className='teamTest'
        style={{
          top: this.props.appStore!.showTeamTest ? (this.props.appStore!.isMobile ? 0 : 50) : screen.height,
          height: this.props.appStore!.podcastToPlay ? (this.props.appStore!.isMobile ? "calc(100% - 101px)" : "calc(100% - 151px)") : (this.props.appStore!.isMobile ? "100%" : "calc(100% - 50px)")
        }}
      >
        <div className="teamTestCover">
          <div
            className="teamTestCoverImage"
            style={{
              backgroundImage: `url(https://dojo.mindjuice.com/images/teamtest-header.png)`
            }}
          />
        </div>
        <div className='teamTestContentWrapper'>
          {this.state.showButtons &&
            <div
              className='closeButton'
              onClick={() => {
                this.setState({ showButtons: false });
                this.props.appStore!.showTeamTest = undefined;
                //history.back();
              }}
            />
          }
          {this.state.showButtons && this.state.hasAccess &&
            <div
              className='createGroupBtn'
              onClick={() => {
                this.props.appStore!.groupToEdit = {
                  type: "Enneagrammy",
                  admins: [this.props.appStore!.user?.id],
                };
              }}
            >
              {window.loc.strings.createGroup.toUpperCase()}
            </div>
          }
          <div className='teamTestContent'>
            <div className="teamTestGroups">
              {this.state.loadingGroups ? (
                <div>Loading...</div>
              ) : (
                (adminGroups?.length === 0 ? (
                  <div className="noGroups">
                    {window.loc.strings.noGroups}
                  </div>
                ) : (
                  <div className='groups'>
                    {adminGroups}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <GroupsPanel
          id={this.props.appStore!.groupToEdit?.objectId}
          save={() => {
            if (this.props.appStore!.groupToEdit?.objectId) {
              GroupService.updateGroup(this.props.appStore!.groupToEdit).then(() => {
                this.props.appStore!.groupToEdit = undefined;
                this.getMyGroups();
              });
            } else {
              GroupService.createGroup(this.props.appStore!.groupToEdit).then(() => {
                this.props.appStore!.groupToEdit = undefined;
                this.getMyGroups();
              });
            }
          }}
          delete={() => {
            this.props.appStore!.groupToEdit = undefined;
            this.getMyGroups();
          }}
        />
      </div>
    );
  }
}